module.exports = __webpack_public_path__ + "96bcaf515bbe704685f9c25ace457005.png";